import { render, staticRenderFns } from "./TelemetryThrottlePedalParts.vue?vue&type=template&id=b38147d8&scoped=true"
import script from "./TelemetryThrottlePedalParts.vue?vue&type=script&lang=ts"
export * from "./TelemetryThrottlePedalParts.vue?vue&type=script&lang=ts"
import style0 from "./TelemetryThrottlePedalParts.vue?vue&type=style&index=0&id=b38147d8&prod&lang=scss&scoped=true"
import style1 from "./TelemetryThrottlePedalParts.vue?vue&type=style&index=1&id=b38147d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38147d8",
  null
  
)

export default component.exports